import { SetStateAction, useState,useEffect} from 'react';
import LocalStorage from '../../helpers/localstorage';
import { Link, useNavigate } from 'react-router-dom';
import { Zip_Code_Api } from '../../services/zip_code_api/zip_code_api';
import { apiClientSubmaster } from '../../services/setupClientSubmaster/apiClientSubmaster';
import { toast } from 'react-toastify';
import { setupAPIclient } from '../../services/setupAPIclientAuth';
import logo_tipo from '../../components/dashboard/img/favicon/logo_tipo_contrato.png';
import "bootstrap-icons/font/bootstrap-icons.css";



interface LayoutProps {
  children: React.ReactNode; 
}

const formatPostalCode = (value: string) => {
  const digitsOnly = value.replace(/\D/g, '').slice(0, 8);
  return digitsOnly.replace(/^(\d{5})(\d)/, '$1-$2');
};

const LayoutSubmaster: React.FC<LayoutProps> = ({ children }) => {


  let localStorage = new LocalStorage()
  const canManageUsers = localStorage.isWebMasterOrLegacy();
  const canEditCompany = localStorage.hasWebPermission("canCompanyEdit");
  const companyMenuLogo = localStorage.getSubmasterLogoUrl()
    ? `https://alexios.com.br:9597/uploads/logo/${localStorage.getSubmasterLogoUrl()}`
    : null;

  
  
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [closeModal, setCloseModal] = useState(false);
  const [showModalUpdateSubmaster , setshowModalUpdateSubmaster ] = useState(false);

  const [showModalValidationNumber, setshowModalValidationNumber] = useState(false)


  const [formData, setFormData] = useState<{
    name: string;
    email: string;
    address: string;
    neighborhood: string;
    postal_code: string;
    cnpj: string;
    cpf: string;
    city: string;
    state: string;
    password: string;
    number: string;
    access_permission_request: boolean;
    submaster_logo_url: string;
    number_house: string;
    fantasy_name: string;
  }>({
    name: '',
    email: '',
    address: '',
    neighborhood: '',
    postal_code: '',
    cnpj: '',
    cpf: '',
    city: '',
    state: '',
    password: '',
    number: '',
    access_permission_request:false,
    submaster_logo_url: "",
    number_house: "",
    fantasy_name: ""

  });


  const [password, setpassword] = useState<{
    password: string;
  }>({
    password: '',
  });

  const navigate = useNavigate();
  const toggleMenu = () => {
    setIsCollapsed(!isCollapsed);
  };
  const logout = () => {
    localStorage.removeAuthToken()
    navigate("/")
  }
  const toggleMenus = () => {
    setIsCollapsed(!isCollapsed);
  };
  const [userName, setUserName] = useState<string | null>(null);
  const [submaster_logo_urlendpoint, setsubmaster_logo_urlendpoint] = useState("");
  const [logoFile, setLogoFile] = useState<File | null>(null);
  const [logoNewPreview, setLogoNewPreview] = useState<string | null>(null);

  useEffect(() => {
    if (!logoFile) {
      setLogoNewPreview(null);
      return;
    }
    const url = URL.createObjectURL(logoFile);
    setLogoNewPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [logoFile]);

  const handleLogoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    if (file) {
      if (!file.type.startsWith('image/')) {
        toast.warning('A logo deve ser um arquivo de imagem.');
        e.target.value = '';
        return;
      }
      if (file.size > 3 * 1024 * 1024) {
        toast.warning('A logo deve ter no máximo 3 MB.');
        e.target.value = '';
        return;
      }
    }
    setLogoFile(file);
  };

  const [userEmail, setUserEmail] = useState<string | null>(null);

 async function handleChangePostalcode(
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
) {
  const rawValue = e.target.value.replace(/\D/g, '').slice(0, 8); // Remove caracteres não numéricos

  // Atualiza o estado com o valor digitado
  setFormData((prevFormData) => ({
    ...prevFormData,
    postal_code: formatPostalCode(rawValue),
  }));

  if (rawValue.length === 8) {
    // Exibe toast fixo enquanto busca o CEP
    const toastId = toast.info("Buscando CEP...", {
      position: "top-right",
      autoClose: false,
      closeOnClick: false,
      draggable: false,
      closeButton: false,
    });

    try {
      const apiclient = Zip_Code_Api(rawValue);
      const response = await apiclient.get("");

      if (response && response.data) {
        if (response.data.erro === "true" || response.data.erro === true) {
          throw new Error("CEP não encontrado.");
        }

        setFormData((prevFormData) => ({
          ...prevFormData,
          neighborhood: response.data.bairro,
          state: response.data.estado,
          city: response.data.localidade,
          address: response.data.logradouro,
        }));

        toast.success("Endereço encontrado", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error: any) {
      toast.update(toastId, {
        render: error.message || "Erro ao buscar o CEP.",
        type: "error",
        autoClose: 3000,
      });
    } finally {
      toast.dismiss(toastId);
    }
  }
}


  // Função para formatar número de telefone
  function maskPhone(e: React.ChangeEvent<HTMLInputElement>){
      let phone = e.target.value;
      phone = phone.replace(/\D/g, ''); // Remove tudo o que não é número
      phone = phone.replace(/(\d{2})(\d)/, '($1) $2');
      phone = phone.replace(/(\d{5})(\d{1,4})$/, '$1-$2');
       setFormData({ ...formData, number: phone });
  };

  function maskCPF(e: React.ChangeEvent<HTMLInputElement>) {
    let cpf = e.target.value;
    cpf = cpf.replace(/\D/g, ''); // Remove tudo o que não é número
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
     setFormData({ ...formData, cpf });
  }


  const maskCNPJ = (e: React.ChangeEvent<HTMLInputElement>) => {
    let cnpj = e.target.value.replace(/\D/g, "");
    cnpj = cnpj.replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
    setFormData((prev: formData) => ({ ...prev, cnpj }));
  };


  const validateFormData = (formData: any) => {
    const requiredFields = [
      { key: "name", label: "O nome é obrigatório." },
      { key: "email", label: "O e-mail é obrigatório." },
      { key: "address", label: "O endereço é obrigatório." },
      { key: "neighborhood", label: "O bairro é obrigatório." },
      { key: "postal_code", label: "O CEP é obrigatório." },
      { key: "cnpj", label: "O CNPJ é obrigatório." },
      { key: "city", label: "A cidade é obrigatória." },
      { key: "state", label: "O estado é obrigatório." },
      { key: "number_house", label: "O número da residência é obrigatório." }
    ];

    for (const field of requiredFields) {
      const value = formData[field.key];
      if (!value || (typeof value === "string" && !value.trim())) {
        toast.error(field.label);
        return false;
      }
    }

    // Validação específica para o campo postal_code (CEP)
    const cep = formData.postal_code?.replace(/\D/g, ""); // Remove não numéricos
    if (!cep || cep.length !== 8) {
      toast.error("O CEP deve conter exatamente 8 dígitos.");
      return false;
    }

    return true;
  };




  const getAuthToken = () => {
    const name = localStorage.getName();
    const email = localStorage.getEmail();

    setUserName(name)
    setUserEmail(email)
   // setsubmaster_logo_urlendpoint("https://alexios.com.br:9597/uploads/logo/" + localStorage.getSubmasterLogoUrl())


    return localStorage.getAuthToken();
  }
  
  const handleSubmitUpdateSubmaster = async (updatedNumberValidated:boolean, number:string) => {

    
    if(formData.email === ""){
      toast.warning("O campo e-mail deve ser preenchido!")
    }
    else
    {

      if (!validateFormData(formData)) {
        return;
      }

      toast.dismiss(loadingToast());
      try {

        const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
        const data = new FormData();

        // const file = 

        // remove tudo que não for número antes de enviar
        const cnpjOnlyNumbers = formData.cnpj.replace(/\D/g, '');




          data.append('name', formData.name);
          data.append('email', formData.email);
          data.append('address', formData.address);
          data.append('neighborhood', formData.neighborhood);
          data.append('postal_code', formData.postal_code.replace(/\D/g, ''));
          data.append('city', formData.city);
          data.append('state', formData.state);
          data.append('cpf', formData.cpf);
          data.append('cnpj', cnpjOnlyNumbers);
          data.append('number_house', formData.number_house);
          // Se o usuário escolheu uma nova logo, envia o arquivo; senão mantém a atual (string).
          if (logoFile) {
            data.append('submaster_logo_url', logoFile);
          } else {
            data.append('submaster_logo_url', formData.submaster_logo_url);
          }
          data.append('fantasy_name', formData.fantasy_name);

          if( password.password !== ""){
            data.append('password', password.password);
          }else{
            // data.append('password', "vazio");
          }

          console.log(formData.submaster_logo_url);
          const response = await ApiClient.post(
              `/crud/updatesubmaster/Submaster/${String(localStorage.getId())}`,
              data,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
          );

        if (response.status >= 200 && response.status < 300) {
          toast.success("Usuário atualizado com sucesso!");
          // Se a logo foi trocada, reflete o novo arquivo no estado, no preview e no localStorage.
          const updatedLogo = response?.data?.submaster_logo_url;
          if (logoFile && updatedLogo) {
            setFormData((prev) => ({ ...prev, submaster_logo_url: updatedLogo }));
            setsubmaster_logo_urlendpoint(`https://alexios.com.br:9597/uploads/logo/${updatedLogo}`);
            localStorage.saveSubmasterLogoUrl(updatedLogo);
            setLogoFile(null);
          }
          /*setTimeout(() => {
            window.location.reload();
          }, 1000);*/
        } else {
          throw new Error(`Erro inesperado: ${response.status}`);
        }
      } catch (error) {
          console.error("Erro ao atualizar usuário:", error);
          //toast.dismiss(loadingToast());
          //toast.error("Erro ao atualizar o usuário. Tente novamente.");
      }
    }
  }
  // Função para manipular a mudança nos inputs
  function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>){
    const { name, value } = e.target;  
    setFormData({
      ...formData,  
      [name]: value, 
    });
  };


  
  // Função para manipular a mudança nos inputs
  function handleChangepassword(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>){
    const { name, value } = e.target;  
    setpassword({
      ...password,  
      [name]: value, 
    });
  };

  const [getData, setgetData] = useState<DataRow[]>([]);


  const formatCNPJ = (value: string) => {
  if (!value) return '';
  const v = value.replace(/\D/g, ''); // remove tudo que não é número
  return v
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
};




  const handlegetActivisionData = async () => {

    const ApiClient = apiClientSubmaster(String(localStorage.getAuthToken()));
    const response = await ApiClient.post("/crud/getdata/Submaster/" + String(localStorage.getId())  + "/true" );

    console.log("dados submaster",response.data)




    const formattedData = response.data.map((item: any) => ({
        name: item.name,
        email: item.email,
        number: item.number,
        address: item.address,
        neighborhood: item.neighborhood,
        postal_code: formatPostalCode(item.postal_code ?? ''),
        city: item.city,
        state: item.state,
        is_registered_in_app: item.is_registered_in_app ?? false,
        active: item.active ?? false,
        access_permission_request: item.access_permission_request ?? false,
        cnpj: formatCNPJ(item.cnpj) ?? '',
        cpf: item.cpf ?? '' ,
        submaster_logo_url: item.submaster_logo_url ?? "",
        number_house: item.number_house ?? "",
        fantasy_name:item.fantasy_name
    }),    

    setsubmaster_logo_urlendpoint(`https://alexios.com.br:9597/uploads/logo/${response.data[0].submaster_logo_url}`)
      
  );

    const firstItem = formattedData.length > 0 ? formattedData[0] : {};
    setFormData({
      name: firstItem.name ?? '',
      email: firstItem.email ?? '',
      address: firstItem.address ?? '',
      neighborhood: firstItem.neighborhood ?? '',
      postal_code: formatPostalCode(firstItem.postal_code ?? ''),
      cnpj: firstItem.cnpj ?? '',
      cpf: firstItem.cpf ?? '',
      city: firstItem.city ?? '',
      state: firstItem.state ?? '',
      password: firstItem.password ?? '',
      number: firstItem.number ?? '',
      access_permission_request: firstItem.access_permission_request ?? false,
      submaster_logo_url: firstItem.submaster_logo_url ?? "",
      number_house: firstItem.number_house ?? "",
      fantasy_name: firstItem.fantasy_name ?? ""
    });
  }
  const [isPermissionGranted, setPermissionGranted] = useState(false);
  const [isPermissionNumberTel, setPermissionNumberTel] = useState(false);

  const isUserActive = async () => {
    try {
        const token = String(getAuthToken());
        const ApiClient = apiClientSubmaster(token);
        const res = await ApiClient.post("/isUserActive", { token });
        console.log(res.data["data"])
        if(res.data["data"][0]["number_active"] === false){

          setPermissionNumberTel(true)
          toast.warning("Para uma melhor experiência no sistema, por favor, valide o número do seu celular.")
        }
        if(res.data["data"][0]["access_permission_request"] === false){
          setPermissionGranted(true)
        }
    } catch (error) {
        console.error("Erro ao ativar usuário", error);
    }
 };

 const loadingToast  = () => {
  return toast.info("Processando... aguarde", {
    autoClose: false, 
  })
 };

  const [openRelatorio, setOpenRelatorio] = useState(false);
  const [openPersonalizacao, setOpenPersonalizacao] = useState(false);
  const [stockControlAllowed, setStockControlAllowed] = useState(false);
  const [individualPhotoReportAllowed, setIndividualPhotoReportAllowed] = useState(false);

  useEffect(() => {
    let active = true;

    const loadStockPermission = async () => {
      try {
        const storage = new LocalStorage();
        const ApiClient = apiClientSubmaster(String(storage.getAuthToken()));
        const response = await ApiClient.post("/reportPermissions", {});
        if (active) {
          setStockControlAllowed(
            response?.data?.stock_control_permission_enabled === true
          );
          setIndividualPhotoReportAllowed(
            response?.data?.report_individual_photo_by_epi_permission_enabled === true
          );
        }
      } catch (error) {
        console.error("Erro ao carregar permissão de controle de estoque:", error);
        if (active) {
          setStockControlAllowed(false);
          setIndividualPhotoReportAllowed(false);
        }
      }
    };

    loadStockPermission();
    return () => {
      active = false;
    };
  }, []);



  useEffect(() => {
    handlegetActivisionData();
    getAuthToken()
  }, []);

  return (
    <div className="layout-wrapper layout-content-navbar centerLayout app-shell">
          <div className="layout-container">
          { 
            isCollapsed ? 
            (
              <div></div>
          ) : (  
              <aside
              id="layout-menu"
              className={`layout-menu menu-vertical menu bg-menu-theme app-sidebar `}
            >
              <div className="app-brand demo">
                  <span className="app-brand-logo demo">
                    {/* SVG logo here */}
                  </span>
                  <button
                  type="button"
                  onClick={toggleMenus}
                  className="layout-menu-toggles menu-links text-large ms-auto d-xl-none iconecolor app-brands bg-menu-themes btn btn-link"
                >
                    <i className="bx bx-chevron-left bx-sm align-middle"></i>
                  </button>
      
            
                <div className="d-flex align-items-center mb-3 ml-3 mt-3">
                  <img
                    src={logo_tipo}
                    className="img-fluid"
                    alt="Logo"

                    style={{ maxWidth: '150px', height: '150px' }}

                  />
                </div>

              
      
                <button
                  type="button"
                  className="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none btn btn-link"
                  onClick={toggleMenus}
                >
                  <i className={`bx bx-chevron-${isCollapsed ? 'right' : 'left'} bx-sm align-middle`}></i>
                </button>
              </div>
      
              <div className="menu-inner-shadow"></div>
              <ul className="menu-inner py-1">
                {/* Dashboard */}
                {!isPermissionGranted && (
                  
                  <li className="menu-item">
                  <Link to="/HomeSubmasterPage" className="menu-link menu-toggle">
                      <i className="menu-icon tf-icons bx bx-home-alt"></i>
                      <div>Início</div> 
                  </Link>

                  <Link to="/ConfigSubmasterEmployeesPage" className="menu-link menu-toggle">
                      <i className="menu-icon bx bx-user-circle"></i>
                      <div>Funcionário</div>
                  </Link>

                  {stockControlAllowed && (
                    <Link to="/ConfigSubmasterStockPage" className="menu-link menu-toggle">
                      <i className="menu-icon bx bx-package"></i>
                      <div>Estoque</div>
                    </Link>
                  )}

                  {canManageUsers && <Link to="/ConfigSubmasterUserPage" className="menu-link menu-toggle">
                      <i className="menu-icon bx bx-user"></i>
                      <div>Usuário</div>
                  </Link>}

                  <Link to="/ConfigSubmasterEpiPage" className="menu-link menu-toggle">
                      <i className="menu-icon bx bx-shield-alt"></i>
                      <div>EPI</div>
                  </Link>

                  <Link to="/ConfigSubmasterCompanyPage" className="menu-link menu-toggle">
                      <i className="menu-icon bx bx-buildings"></i>
                      <div>Criar empresa</div>
                  </Link>

                  {/*<Link to="/ConfigDocumentEmployeePage" className="menu-link menu-toggle">
                    <i className="menu-icon bx bxs-file-pdf"></i>
                    <div>D.Documentos</div>
                  </Link> */}

     
                  {/* Relatório */}
                    <div className='menu-link menu-toggle'
                      onClick={() => setOpenRelatorio(!openRelatorio)}
                      style={{ cursor: "pointer",  marginBottom: 4 }}
                    >
                      <i className="menu-icon bx bx-file" />
                      <div>Relatório</div>
                    </div>
                    {openRelatorio && (
                      <ul style={{ marginLeft: 20,color: 'black' }}>
                        <li>
                          <Link style={{ color: 'black', textDecoration: 'none' }} to="/ConfigReportDocument">Conjunto</Link>
                        </li>
                        <hr/>
                        <li>
                          <Link to="/ConfigDocumentEmployeePage" style={{ color: 'black', textDecoration: 'none' }}> Individual</Link>
                        </li>
                        {individualPhotoReportAllowed && (
                          <>
                            <hr/>
                            <li>
                              <Link
                                to="/ConfigDocumentEmployeePhotoPage"
                                style={{ color: 'black', textDecoration: 'none' }}
                              >
                                Individual com Foto por EPI
                              </Link>
                            </li>
                          </>
                        )}
                      </ul>
                    )}

                  <Link to="/ConfigAdditionalReportPage" className="menu-link menu-toggle">
                      <div className="d-flex align-items-center gap-2">
                        <span className="d-flex align-items-center gap-1">
                          {companyMenuLogo ? (
                            <img
                              src={companyMenuLogo}
                              alt="Empresa"
                              className="rounded-circle border bg-white"
                              style={{ width: 20, height: 20, objectFit: 'cover' }}
                            />
                          ) : (
                            <i className="menu-icon bx bx-buildings"></i>
                          )}
                          <img
                            src={logo_tipo}
                            alt="Track EPI"
                            className="rounded-circle border bg-white"
                            style={{ width: 20, height: 20, objectFit: 'contain', padding: 2 }}
                          />
                        </span>
                        <div>Relatório Adicional</div>
                      </div>
                  </Link>


                  {/* Personalização */}
                  {canEditCompany && <>
                    <div
                      onClick={() => setOpenPersonalizacao(!openPersonalizacao)}
                      style={{ cursor: "pointer", marginBottom: 4 }}
                      className='menu-link menu-toggle'
                    >
                      <i className="menu-icon bx bx-edit-alt" />
                      <div>Personalização</div>
                    </div>
                    {openPersonalizacao && (
                      <ul style={{ marginLeft: 20 }}>
                        <li>
                          <Link to="/ConfigEditTextDoc" style={{ color: 'black', textDecoration: 'none' }}>Editar.doc</Link>
                        </li>
                      </ul>
                    )}
                  </>}
                  </li>
                )}
              </ul>
              </aside> 

              
            )
          }


        <style jsx>{`
  /* Links do menu */
  .menu-link {
    position: relative;
    border-radius: 8px;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    color: #2c3e50; /* texto inicial */
    font-weight: 500;
    transition: all 0.3s ease;
    background-color: transparent;
  }

  /* Hover: transição de cinza claro para branco suave */
  .menu-link:hover {
    background-color: #d3d3d3; /* cinza claro inicial */
    background-image: linear-gradient(90deg, #d3d3d3, #ffffff); /* gradiente suave para branco */
    color: #fff;               /* texto branco */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12); /* sombra leve */
    transform: translateX(3px); /* leve deslocamento */
    transition: all 0.35s ease-in-out;
  }

  /* Ícone no hover */
  .menu-link:hover .menu-icon {
    transform: scale(1.1);               /* aumenta levemente */
    color: #fff;                         /* ícone branco */
    text-shadow: 0 0 6px rgba(255,255,255,0.5); /* glow suave */
    transition: transform 0.35s ease-in-out, text-shadow 0.35s ease-in-out, color 0.35s ease-in-out;
  }

  /* Submenus */
  .submenu-link {
    display: block;
    padding: 4px 8px;
    color: #34495e;
    border-radius: 6px;
    transition: all 0.3s ease;
  }

  .submenu-link:hover {
    color: #fff;                      /* texto branco */
    background-color: #e8e8e8;        /* cinza claro */
    transform: translateX(2px);
  }
`}</style>




          <div className="layout-page app-page">
          <nav className="col-md-12 layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme app-topbar" id="layout-navbar">
            <div className="layout-menu-toggle ">
              <button type="button" className="nav-item nav-link px-0 me-xl-4 btn btn-link" onClick={toggleMenu}>
                <i className="bx bx-menu bx-sm"></i>
              </button>
            </div>

            <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
              {/* Search */}
              <div className="navbar-nav align-items-center">
                <div className="nav-item d-flex align-items-center app-search">
                  <i className="bx bx-search fs-4 lh-0"></i>
                  <input type="text" className="form-control border-0 shadow-none" placeholder="Pesquisar..." aria-label="Pesquisar" />
                </div>
              </div>

              {/* User Dropdown */}
              <ul className="navbar-nav flex-row align-items-center ms-auto">
                <li className="nav-item navbar-dropdown dropdown-user dropdown">
                  <button type="button" className="nav-link dropdown-toggle hide-arrow btn btn-link"  data-bs-toggle="dropdown">
                    
                    <div className="avatar avatar-online">
                     <img src={logo_tipo} alt="Avatar" className="w-px-20  rounded-circle" />
                    </div>
                  
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <div className="dropdown-item">
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3">
                            <div className="avatar avatar-online">
                              <img src={logo_tipo} alt="Avatar" className="w-px-20  rounded-circle" />
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <span className="fw-semibold d-block">{userName}</span>
                            <small className="text-muted">Administrador</small>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li><div className="dropdown-divider"></div></li>

                    {canEditCompany && <li onClick={() => setshowModalUpdateSubmaster(true)}>
                      <button type="button" className="dropdown-item">
                        <i className="bx bx-user me-2"></i>
                        <span>Editar perfil</span>
                      </button>
                    </li>}

                    <li><div className="dropdown-divider"></div></li>
                    <li>
                      <button type="button" className="dropdown-item" onClick={logout}>
                        <i className="bx bx-power-off me-2"></i>
                        <span>Sair</span>
                      </button>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </nav>

            <div className="content-wrapper app-content">

              {/* Content */}

      


              <div className="d-flex justify-content-center align-items-center mt-3 ml-1 mr-1 centercard ">
                <div className='col-md-12'>

                {isPermissionGranted && (<div>
                  <div className="alert alert-warning" role="alert">
                    Pendente de validação, por favor aguarde!
                  </div>
                </div>) }
              
                {children}
                </div>
              </div>



              
              {/* Footer */}
              <footer className="content-footer footer bg-footer-theme app-footer">
                <div className="container-xxl d-flex flex-wrap justify-content-between py-2 flex-md-row flex-column">
                  <div className="mb-2 mb-md-0">© 2026 Track EPI</div>
                </div>
              </footer>
            </div>
            {/* / Content wrapper */}
          </div>
          </div>








           {(showModalUpdateSubmaster) && (

              <div className="modal fade show d-block">
              <div className="modal-dialog modal-xl">
                <div
                  className="modal-content"
                  style={{
                    borderRadius: "16px",
                    overflow: "hidden",
                    boxShadow: "0 0.5rem 1rem rgba(0,0,0,0.3)",
                    border: "none",
                  }}
                >
                  {/* Cabeçalho */}
                  <div
                    className="modal-header"
                    style={{
                      background: "linear-gradient(90deg, #0d6efd, #5dade2)",
                      color: "#fff",
                    }}
                  >
                    <h5 className="modal-title d-flex align-items-center" style={{ color: "#fff" }}>
                      <i className="bi bi-pencil-square me-2"></i> Editar seu perfil
                    </h5>
                    <button
                      type="button"
                      className="btn-close btn-close-white mr-3 mt-3"
                      onClick={() => setshowModalUpdateSubmaster(false)}
                    ></button>
                  </div>

                  {/* Corpo */}
                  <div className="modal-body">
                    <form method="POST">
                      {/* Nome e Email */}
                      <div className="row">
                        
                        <div className="col-md-6">
                          <label className="form-label">Nome fantasia</label>
                          <div className="input-group">
                            <span className="input-group-text" style={{ color: "#0d6efd" }}>
                              <i className="bi bi-person"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              name="fantasy_name"
                              placeholder="Nome fantasia"
                              value={formData.fantasy_name}
                              onChange={handleChange}
                              required
                              style={{ borderRadius: "8px" }}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <label className="form-label">Nome</label>
                          <div className="input-group">
                            <span className="input-group-text" style={{ color: "#0d6efd" }}>
                              <i className="bi bi-person"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              name="name"
                              placeholder="Nome"
                              value={formData.name}
                              onChange={handleChange}
                              required
                              style={{ borderRadius: "8px" }}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <label className="form-label">E-mail</label>
                          <div className="input-group">
                            <span className="input-group-text" style={{ color: "#0d6efd" }}>
                              <i className="bi bi-envelope"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              name="email"
                              placeholder="E-mail"
                              value={formData.email}
                              onChange={handleChange}
                              required
                              style={{ borderRadius: "8px" }}
                            />
                          </div>
                        </div>

                         <div className="col-md-6">
                          <label className="form-label">Bairro</label>
                          <div className="input-group">
                            <span className="input-group-text" style={{ color: "#0d6efd" }}>
                              <i className="bi bi-geo-alt"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              name="neighborhood"
                              placeholder="Bairro"
                              value={formData.neighborhood}
                              onChange={handleChange}
                              style={{ borderRadius: "8px" }}
                              required
                            />
                          </div>
                        </div>
                      </div>

                      {/* Endereço e Bairro */}
                      <div className="row g-3 mt-3">
                        <div className="col-md-6">
                          <label className="form-label">Endereço</label>
                          <div className="input-group">
                            <span className="input-group-text" style={{ color: "#0d6efd" }}>
                              <i className="bi bi-house"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              name="address"
                              placeholder="Endereço"
                              value={formData.address}
                              onChange={handleChange}
                              style={{ borderRadius: "8px" }}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <label className="form-label">Senha</label>
                          <div className="input-group">
                            <span className="input-group-text" style={{ color: "#0d6efd" }}>
                              <i className="bi bi-key"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              name="password"
                              placeholder="Alteração de senha"
                              value={password.password}
                              onChange={handleChangepassword}
                              required
                              style={{ borderRadius: "8px" }}
                            />
                          </div>
                        </div>
                      
                      </div>

                      {/* CEP e CNPJ */}
                      <div className="row g-3 mt-3">
                        <div className="col-md-6">
                          <label className="form-label">CEP</label>
                          <p className="control_cep">
                            Para buscar o bairro e o endereço automaticamente, digite o CEP.
                          </p>
                          <div className="input-group">
                            <span className="input-group-text" style={{ color: "#0d6efd" }}>
                              <i className="bi bi-geo-fill"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              name="postal_code"
                              placeholder="CEP"
                              value={formData.postal_code}
                              onChange={handleChangePostalcode}
                              maxLength={9}
                              required
                              style={{ borderRadius: "8px" }}
                            />
                          </div>
                        </div>
                        
                        <div className="col-md-6 mt-5">
                          <label className="form-label">CNPJ</label>
                            <div className="input-group">
                              <span className="input-group-text" style={{ color: "#0d6efd" }}>
                                <i className="bi bi-building"></i>
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                name="cnpj"
                                placeholder="CNPJ"
                                value={formData.cnpj}
                                onChange={maskCNPJ}
                                style={{ borderRadius: "8px" }}
                              />
                            </div>
                        </div>
                      </div>

                      {/* CPF e Cidade */}
                      <div className="row g-3 mt-3">
                        <div className="col-md-6">
                          <label className="form-label">Cidade</label>
                          <div className="input-group">
                            <span className="input-group-text" style={{ color: "#0d6efd" }}>
                              <i className="bi bi-geo"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              name="city"
                              placeholder="Cidade"
                              value={formData.city}
                              onChange={handleChange}
                              required
                              style={{ borderRadius: "8px" }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Estado e Senha */}
                      <div className="row g-3 mt-3">
                        <div className="col-md-6">
                          <label className="form-label">Estado</label>
                          <div className="input-group">
                            <span className="input-group-text" style={{ color: "#0d6efd" }}>
                              <i className="bi bi-flag"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              name="state"
                              placeholder="Estado"
                              value={formData.state}
                              onChange={handleChange}
                              required
                              style={{ borderRadius: "8px" }}
                            />
                          </div>
                        </div>
                        
                      </div>

                      

                      {/* Número da casa e Avatar */}
                      <div className="row g-3 mt-3">
                        <div className="col-md-6">
                          <label className="form-label">Número de residência</label>
                          <div className="input-group">
                            <span className="input-group-text" style={{ color: "#0d6efd" }}>
                              <i className="bi bi-house-door"></i>
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              name="number_house"
                              placeholder="Número de residência"
                              value={formData.number_house}
                              onChange={handleChange}
                              required
                              style={{ borderRadius: "8px" }}
                            />
                          </div>
                        </div>

                      </div>

                      {/* Logo da empresa */}
                      <div className="row g-3 mt-3">
                        <div className="col-md-12">
                          <label className="form-label">Logo da empresa</label>
                          <p className="control_cep">
                            Esta logo aparece nos relatórios em PDF da empresa.
                          </p>
                          <div className="d-flex align-items-center gap-3 flex-wrap">
                            <div
                              style={{
                                width: 84,
                                height: 84,
                                borderRadius: 12,
                                overflow: "hidden",
                                border: "1px solid rgba(13,110,253,0.25)",
                                background: "#f5f7fb",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flex: "0 0 auto",
                              }}
                            >
                              {logoNewPreview ? (
                                <img
                                  src={logoNewPreview}
                                  alt="Nova logo"
                                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                />
                              ) : submaster_logo_urlendpoint && formData.submaster_logo_url ? (
                                <img
                                  src={submaster_logo_urlendpoint}
                                  alt="Logo atual"
                                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                />
                              ) : (
                                <i className="bi bi-image" style={{ fontSize: 26, opacity: 0.5 }}></i>
                              )}
                            </div>
                            <div className="flex-grow-1" style={{ minWidth: 220 }}>
                              <input
                                type="file"
                                accept="image/*"
                                className="form-control"
                                onChange={handleLogoChange}
                                style={{ borderRadius: "8px" }}
                              />
                              <small className="text-secondary">
                                PNG ou JPG, até 3 MB.{logoFile ? " Nova logo selecionada." : ""}
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  {/* Footer */}
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary d-flex align-items-center"
                      style={{ borderRadius: "8px" }}
                      onClick={() => setshowModalUpdateSubmaster(false)}
                    >
                      <i className="bi bi-x-lg me-2"></i> Fechar
                    </button>
                    <button
                      className="btn btn-outline-primary d-flex align-items-center"
                      style={{ borderRadius: "8px" }}
                      onClick={() => handleSubmitUpdateSubmaster(false, "")}
                    >
                      <i className="bi bi-save me-2"></i> Editar
                    </button>
                  </div>
                </div>
              </div>
              </div>


          )}

    </div>

  );
};

export default LayoutSubmaster;
